// The "Page Sections" links in the right-hand rail of the Update Journey screen.
// `page` says which screen an anchor lives on ("journey" = this screen, "stats" =
// Your Stats) so the rail renders an in-page #anchor when the section is on the
// current screen and a route link otherwise; an explicit `to` points at another
// TSP screen. `icon` is a name from utils/tspIcons.js.
export const JOURNEY_RAIL_SECTIONS = Object.freeze([
  { id: "overview", label: "Overview", icon: "MapPin", page: "journey" },
  { id: "execution-workflow", label: "Execution Workflow", icon: "Check", page: "journey" },
  { id: "city-activities", label: "City Activities", icon: "CircleDot", page: "journey" },
  { id: "distribution-summary", label: "Distribution Summary", icon: "FileText", page: "stats" },
  { id: "public-response", label: "Public Response", icon: "Star", page: "stats" },
  { id: "logistics", label: "Accommodation", icon: "Building2", page: "stats" },
  { id: "media-gallery", label: "Media Gallery", icon: "Camera", page: "stats" },
  { id: "reports", label: "Generate Reports", icon: "FileText", to: "/tsp/reports" },
]);
